export var sessionIdQuery = "\n  query sessionIdQuery {\n    oneIncSessionIdV2\n  }\n";

export var savePaymentSessionIdQuery = "\n  query sessionIdQuery {\n    oneIncSavePaymentSessionId\n  }\n";

export var paymentMutation = "\n  mutation paymentMutation($payment: Payment!) {\n    registerPayment(payment: $payment)\n  }\n";

export var saveCreditCardMethodMutation = "\n  mutation saveCreditCardMethodMutation($method: CreditCardPayment!) {\n    saveCreditCardPayment(payment: $method)\n  }\n";

export var saveACHMethodMutation = "\n  mutation saveACHMethodMutation($method: ECheckPayment!) {\n    saveECheckPayment(payment: $method)\n  }\n";